import { Controller } from 'react-hook-form'

import { useFormContextContact } from '../_utils'
import ContactFormField from '../ContactFormField'

const Speciality = () => {
    const { control, watch } = useFormContextContact()
    const validRpps = watch('validRpps')
    const annIdentifier = watch('annIdentifier')

    return (
        <Controller
            control={control}
            name="speciality"
            render={({ field, fieldState: { error } }) => (
                <ContactFormField
                    variant="input"
                    label="Spécialité"
                    disabled
                    status={{
                        error,
                        valid: Boolean(field.value) || Boolean(!field.value && (validRpps || annIdentifier)),
                    }}
                    size="0.5"
                    dataCyScope="ContactField"
                    {...field}
                    onChange={(e) => {
                        field.onChange(e)
                    }}
                    value={field.value ?? ''}
                    noValueText="Aucune spécialité"
                    placeholder="Spécialité"
                />
            )}
        />
    )
}

export default Speciality
